export default {
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: null
    },
    showError: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      showRequiredError: false,
      isFocused: false
    }
  },
  computed: {
    fieldClass () {
      return {
        'field--disabled': this.disabled,
        'field--error': this.showError || this.showRequiredError,
      }
    },
    hasLabel () {
      return this.label && this.label.length > 0
    },
    form () {
      return this.$el.closest('form')
    },
  },
  watch: {
    value (value) {
      if (value) this.showRequiredError = false
    },
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    handleFocus () {
      this.isFocused = true
      this.$emit('input-focus')
    },
    handleBlur () {
      this.isFocused = false
    },
    handleFormSubmit () {
      if (this.required && this.value === '') {
        this.showRequiredError = true
      }
    },
  },
  mounted () {
    this.form.addEventListener('submit', this.handleFormSubmit)
  },
  beforeDestroy () {
    this.form.removeEventListener('submit', this.handleFormSubmit)
  },
}



// WEBPACK FOOTER //
// ./src/mixins/forms/FormInputMixin.js